import { FC, PropsWithChildren } from "react";

import styles from "./detections.module.scss";

const Detections: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.detections}>{children}</div>
);

export default Detections;
